var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "step-select-document-type p-4" }, [
    _c(
      "form",
      {
        attrs: { "data-vv-scope": "step-1-part-1", autocomplete: "off" },
        on: {
          submit: function($event) {
            $event.preventDefault()
          }
        }
      },
      [
        _c(
          "b-form-group",
          {
            staticClass: "mb-4",
            attrs: {
              label: "Tipo de Documento",
              "label-for": "document-type-select"
            }
          },
          [
            _c("b-form-select", {
              attrs: {
                id: "document-type-select",
                options: _vm.documentTypes,
                size: "lg"
              },
              on: { change: _vm.onTypeSelected },
              scopedSlots: _vm._u([
                {
                  key: "first",
                  fn: function() {
                    return [
                      _c(
                        "b-form-select-option",
                        { attrs: { value: null, disabled: "" } },
                        [_vm._v(" Selecciona un tipo de documento ")]
                      )
                    ]
                  },
                  proxy: true
                }
              ]),
              model: {
                value: _vm.selectedType,
                callback: function($$v) {
                  _vm.selectedType = $$v
                },
                expression: "selectedType"
              }
            })
          ],
          1
        ),
        _c("div", { staticClass: "row mt-1 d-flex align-items-end" }, [
          _vm._m(0),
          _c(
            "div",
            { staticClass: "col-12 d-flex align-items-center mt-5" },
            [
              _c("h6", [_vm._v("Remitente:")]),
              _c(
                "b-form-group",
                [
                  _c(
                    "b-form-radio-group",
                    {
                      attrs: {
                        id: "sender-types",
                        name: "sender-type",
                        disabled: _vm.isBlocked
                      },
                      model: {
                        value: _vm.step.sender,
                        callback: function($$v) {
                          _vm.$set(_vm.step, "sender", $$v)
                        },
                        expression: "step.sender"
                      }
                    },
                    [
                      _c(
                        "b-form-radio",
                        {
                          staticClass: "ml-3 mr-5",
                          attrs: { value: "CIU", "data-cy": "check-citizen" },
                          on: {
                            change: function($event) {
                              return _vm.clearSender()
                            }
                          }
                        },
                        [_vm._v(" Ciudadano/a ")]
                      ),
                      _c(
                        "b-form-radio",
                        {
                          staticClass: "ml-3 mr-5",
                          attrs: { value: "SAN", "data-cy": "health-check" },
                          on: {
                            change: function($event) {
                              return _vm.clearSender()
                            }
                          }
                        },
                        [_vm._v(" Sanitaria ")]
                      ),
                      _c(
                        "b-form-radio",
                        {
                          staticClass: "mr-5",
                          attrs: {
                            value: "PJU",
                            "data-cy": "check-legal-entity"
                          },
                          on: {
                            change: function($event) {
                              return _vm.clearSender()
                            }
                          }
                        },
                        [_vm._v(" Persona Jurídica ")]
                      ),
                      _c(
                        "b-form-radio",
                        {
                          staticClass: "mr-5",
                          attrs: {
                            value: "OES",
                            "data-cy": "check-state-agency"
                          },
                          on: {
                            change: function($event) {
                              return _vm.clearSender()
                            }
                          }
                        },
                        [_vm._v(" Organismo del estado ")]
                      )
                    ],
                    1
                  )
                ],
                1
              )
            ],
            1
          )
        ]),
        _c("div", { staticClass: "row mt-3" }, [
          _c(
            "div",
            { staticClass: "col-6" },
            [
              _c("vs-input", {
                staticClass: "w-100",
                attrs: {
                  autocomplete: "off",
                  label:
                    _vm.step.sender === "CIU" ? "Rut Emisor" : "Rut remitente",
                  "data-vv-as": "rut",
                  name: "senderIut"
                },
                model: {
                  value: _vm.step.senderIut,
                  callback: function($$v) {
                    _vm.$set(_vm.step, "senderIut", $$v)
                  },
                  expression: "step.senderIut"
                }
              })
            ],
            1
          ),
          _c(
            "div",
            { staticClass: "col-6" },
            [
              _c("vs-input", {
                directives: [
                  {
                    name: "validate",
                    rawName: "v-validate",
                    value: "required|max:200",
                    expression: "'required|max:200'"
                  }
                ],
                staticClass: "w-100",
                attrs: {
                  autocomplete: "off",
                  label:
                    _vm.step.sender === "CIU"
                      ? "Nombre *"
                      : "Nombre remitente *",
                  "data-vv-as": "nombre",
                  name: "senderName",
                  danger: _vm.errors.has("step-1-part-1.senderName"),
                  "danger-text": _vm.errors.first("step-1-part-1.senderName")
                },
                model: {
                  value: _vm.step.senderName,
                  callback: function($$v) {
                    _vm.$set(_vm.step, "senderName", $$v)
                  },
                  expression: "step.senderName"
                }
              })
            ],
            1
          )
        ]),
        _c("div", { staticClass: "row mt-3" }, [
          _vm.step.sender === "SAN" || _vm.step.sender === "PJU"
            ? _c(
                "div",
                { staticClass: "col-6" },
                [
                  _c("vs-input", {
                    directives: [
                      {
                        name: "validate",
                        rawName: "v-validate",
                        value: { validateRut: true },
                        expression: "{ validateRut: true }"
                      }
                    ],
                    staticClass: "w-100",
                    attrs: {
                      autocomplete: "off",
                      label: _vm.iutLabel,
                      "data-vv-as": _vm.iutLabel.toLowerCase(),
                      name: "senderCompanyIut",
                      danger: _vm.errors.has("step-1-part-1.senderCompanyIut"),
                      "danger-text": _vm.errors.first(
                        "step-1-part-1.senderCompanyIut"
                      )
                    },
                    model: {
                      value: _vm.step.senderCompanyIut,
                      callback: function($$v) {
                        _vm.$set(_vm.step, "senderCompanyIut", $$v)
                      },
                      expression: "step.senderCompanyIut"
                    }
                  })
                ],
                1
              )
            : _vm._e(),
          _vm.step.sender === "PJU" ||
          _vm.step.sender === "OES" ||
          _vm.step.sender === "SAN"
            ? _c(
                "div",
                { staticClass: "col-6" },
                [
                  _vm.step.sender === "PJU" || _vm.step.sender === "OES"
                    ? _c("vs-input", {
                        directives: [
                          {
                            name: "validate",
                            rawName: "v-validate",
                            value: {
                              required:
                                _vm.step.sender === "PJU" ||
                                _vm.step.sender === "OES",
                              max: "200"
                            },
                            expression:
                              "{\n            required: step.sender === 'PJU' || step.sender === 'OES',\n            max: '200'\n          }"
                          }
                        ],
                        staticClass: "w-100",
                        attrs: {
                          autocomplete: "off",
                          label: _vm.nameLabel,
                          "data-vv-as": _vm.nameLabel
                            .replace("*", "")
                            .toLowerCase(),
                          name: "senderCompanyName",
                          danger: _vm.errors.has(
                            "step-1-part-1.senderCompanyName"
                          ),
                          "danger-text": _vm.errors.first(
                            "step-1-part-1.senderCompanyName"
                          )
                        },
                        model: {
                          value: _vm.step.senderCompanyName,
                          callback: function($$v) {
                            _vm.$set(_vm.step, "senderCompanyName", $$v)
                          },
                          expression: "step.senderCompanyName"
                        }
                      })
                    : _vm._e(),
                  _vm.step.sender === "SAN"
                    ? _c("ListSanitaryCompanies", {
                        directives: [
                          {
                            name: "validate",
                            rawName: "v-validate",
                            value: {
                              required: _vm.step.sender === "SAN",
                              max: "200"
                            },
                            expression:
                              "{\n            required: step.sender === 'SAN',\n            max: '200'\n          }"
                          }
                        ],
                        ref: "sanitaryCompanies",
                        attrs: {
                          autocomplete: "off",
                          "data-vv-as": "empresa sanitaria",
                          name: "senderCompanyName",
                          isClearable: false,
                          label: "Empresas Sanitarias *",
                          clearSanitary: _vm.clearSanitary,
                          danger: _vm.errors.has(
                            "step-1-part-1.senderCompanyName"
                          ),
                          "danger-text": _vm.errors.first(
                            "step-1-part-1.senderCompanyName"
                          )
                        },
                        on: { input: _vm.setSanitary },
                        model: {
                          value: _vm.step.senderCompanyName,
                          callback: function($$v) {
                            _vm.$set(_vm.step, "senderCompanyName", $$v)
                          },
                          expression: "step.senderCompanyName"
                        }
                      })
                    : _vm._e()
                ],
                1
              )
            : _vm._e(),
          _c(
            "div",
            { staticClass: "col-md-6 mt-3" },
            [
              _c("ListProcess", {
                directives: [
                  {
                    name: "validate",
                    rawName: "v-validate",
                    value: "required",
                    expression: "'required'"
                  }
                ],
                ref: "process",
                staticClass: "w-100",
                attrs: {
                  autocomplete: "",
                  label: "Proceso *",
                  placeholder: "Seleccione...",
                  name: "process",
                  "data-vv-as": "proceso",
                  danger: _vm.errors.has("step-1-part-1.process"),
                  "danger-text": _vm.errors.first("step-1-part-1.process")
                },
                on: {
                  "get-option-id": _vm.getOptionId,
                  change: _vm.updateNumeration
                },
                model: {
                  value: _vm.step.process,
                  callback: function($$v) {
                    _vm.$set(_vm.step, "process", $$v)
                  },
                  expression: "step.process"
                }
              })
            ],
            1
          ),
          _c(
            "div",
            { staticClass: "col-md-6 mt-3" },
            [
              _c("ListSubProcess", {
                directives: [
                  {
                    name: "validate",
                    rawName: "v-validate",
                    value: "required",
                    expression: "'required'"
                  }
                ],
                ref: "subProcess",
                staticClass: "w-100",
                attrs: {
                  autocomplete: "",
                  label: "Subproceso *",
                  name: "subProcess",
                  "parent-value": _vm.processId,
                  "data-vv-as": "subproceso",
                  danger: _vm.errors.has("step-1-part-1.subProcess"),
                  "danger-text": _vm.errors.first("step-1-part-1.subProcess")
                },
                on: { change: _vm.updateNumeration },
                model: {
                  value: _vm.step.subProcess,
                  callback: function($$v) {
                    _vm.$set(_vm.step, "subProcess", $$v)
                  },
                  expression: "step.subProcess"
                }
              })
            ],
            1
          )
        ])
      ],
      1
    ),
    _c(
      "form",
      { attrs: { "data-vv-scope": "step-1-part-2" } },
      [
        _vm._m(1),
        _c("SelectSubject", {
          attrs: { scope: "step-1-part-2" },
          on: { "add-subject": _vm.addSubject }
        }),
        _c("div", { staticClass: "row mb-3" }, [
          _c(
            "div",
            { staticClass: "col-12" },
            [
              _vm.step.subjects
                ? _c("TableSubjects", {
                    attrs: { subjects: _vm.step.subjects },
                    model: {
                      value: _vm.step.subjectsSelected,
                      callback: function($$v) {
                        _vm.$set(_vm.step, "subjectsSelected", $$v)
                      },
                      expression: "step.subjectsSelected"
                    }
                  })
                : _vm._e()
            ],
            1
          )
        ]),
        _c("div", { staticClass: "row" }, [
          _vm._m(2),
          _c(
            "div",
            { staticClass: "col-md-1" },
            [
              _c(
                "vs-radio",
                {
                  attrs: { "vs-name": "isPrivate", "vs-value": 2 },
                  model: {
                    value: _vm.step.isPrivate,
                    callback: function($$v) {
                      _vm.$set(_vm.step, "isPrivate", $$v)
                    },
                    expression: "step.isPrivate"
                  }
                },
                [_vm._v(" Si ")]
              )
            ],
            1
          ),
          _c(
            "div",
            { staticClass: "col-md-1" },
            [
              _c(
                "vs-radio",
                {
                  attrs: { "vs-name": "isPrivate", "vs-value": 0 },
                  model: {
                    value: _vm.step.isPrivate,
                    callback: function($$v) {
                      _vm.$set(_vm.step, "isPrivate", $$v)
                    },
                    expression: "step.isPrivate"
                  }
                },
                [_vm._v(" No ")]
              )
            ],
            1
          )
        ])
      ],
      1
    )
  ])
}
var staticRenderFns = [
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "col-12" }, [
      _c("h4", [_vm._v("Identificación del remitente")])
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "row mb-3" }, [
      _c("div", { staticClass: "col-12" }, [
        _c("h4", [_vm._v("Responsable *")]),
        _c("small", [
          _vm._v(
            " Para cambiar el destinatario, solo ingrese uno nuevo y se reemplazará el actual "
          )
        ])
      ])
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "col-md-4" }, [
      _c("label", [_vm._v("Documento Reservado")])
    ])
  }
]
render._withStripped = true

export { render, staticRenderFns }